import { getStrWithCommas, replaceText } from "../../utils/string";

const DEFAULT_CURRENCY_CODE = "USD";
const FORMAT_MAX_PRICE = 10;
const REPLACE_TIER_LIMITS_MAP = {
  lowerLimit: "lowerLimit",
  upperLimit: "upperlimit",
};

export const replaceTierLimitsText = (
  { unitLimitLower, unitLimitUpper },
  inputText
) => {
  const [lowerLimit, upperLimit] = [unitLimitLower, unitLimitUpper].map(
    (limitVal) => getStrWithCommas(limitVal)
  );

  return replaceText(
    { lowerLimit, upperLimit },
    inputText,
    REPLACE_TIER_LIMITS_MAP
  );
};

export const sanitizeUpperLimit = (unitLimitLower, unitLimitUpper) => {
  return unitLimitUpper ? unitLimitUpper : `${unitLimitLower}+`;
};

//  show 2 decimal places in price if USD, not zero, and:
//    either a fractional amount or under $10
export const formatPrice = (price, currencyCode = DEFAULT_CURRENCY_CODE) =>
  currencyCode === DEFAULT_CURRENCY_CODE &&
  price !== 0 &&
  (price % 1 !== 0 || price < FORMAT_MAX_PRICE)
    ? price.toFixed(2)
    : price;
